export var IntelligentPhotoCaptureArtifactsCategoryNames;
(function (IntelligentPhotoCaptureArtifactsCategoryNames) {
    IntelligentPhotoCaptureArtifactsCategoryNames["ADDITIONAL_ARTIFACTS"] = "ADDITIONAL_ARTIFACTS";
    IntelligentPhotoCaptureArtifactsCategoryNames["COLLECTING_ARTIFACTS"] = "COLLECTING_ARTIFACTS";
    IntelligentPhotoCaptureArtifactsCategoryNames["FOUR_CORNERS"] = "FOUR_CORNERS";
    IntelligentPhotoCaptureArtifactsCategoryNames["PRIOR_DAMAGE"] = "PRIOR_DAMAGE";
    IntelligentPhotoCaptureArtifactsCategoryNames["VEHICLE_DAMAGE"] = "VEHICLE_DAMAGE";
    IntelligentPhotoCaptureArtifactsCategoryNames["VEHICLE_INFORMATION"] = "VEHICLE_INFORMATION";
})(IntelligentPhotoCaptureArtifactsCategoryNames || (IntelligentPhotoCaptureArtifactsCategoryNames = {}));
//# sourceMappingURL=IntelligentPhotoCaptureArtifactsCategoryNames.js.map